module.exports = __webpack_public_path__ + "img/brown-treetop.b8604414.svg";